import React from 'react';

const SvgFrequentExpress = ({ title, ...props }) => (
  <svg viewBox="0 0 143.9 144" {...props}>
    {title ? <title>{title}</title> : null}
    <style>{'.frequent-express_svg__st1{fill:#fff}'}</style>
    <g id="frequent-express_svg__circle">
      <path
        d="M144 72c0 39.8-32.2 72-72 72S0 111.8 0 72 32.2 0 72 0s72 32.2 72 72z"
        fill="#6cb33f"
      />
      <path
        className="frequent-express_svg__st1"
        d="M72 138.9c-36.9 0-66.9-30-66.9-66.9 0-36.9 30-66.9 66.9-66.9s66.9 30 66.9 66.9c0 36.9-30 66.9-66.9 66.9zM72 8C36.7 8 8 36.7 8 72s28.7 64 64 64 64-28.7 64-64S107.3 8 72 8z"
      />
      <path
        className="frequent-express_svg__st1"
        d="M30.4 100.5h13.1V78.1h20.2V67H43.5V53.5h23.6V42.4H30.4zM117.2 100.5l-17-30.1 16.1-28h-13.7l-9.2 15.9-9.1-15.9H69.8l16.4 28.5-17.1 29.6h13.8L93 82.8l10.2 17.7z"
      />
    </g>
  </svg>
);

export default SvgFrequentExpress;
